import * as React from 'react'
import { useCallback, useEffect } from 'react'
import { useRouter } from 'next/router'
import { useWindowSize } from '@lib/utils/useWindowSize'
import { NavStateContext } from './context'

type NavProviderProps = { children: React.ReactNode }

export function NavProvider({ children }: NavProviderProps) {
  const [open, setOpen] = React.useState(false)

  const toggle = useCallback(() => {
    setOpen((prev) => !prev)
  }, [])

  const { width } = useWindowSize()
  const isLt768 = (width && width < 768) || false

  const router = useRouter()
  useEffect(() => {
    const handler = () => setOpen(false)
    router.events.on('routeChangeStart', handler)
    return () => {
      router.events.off('routeChangeStart', handler)
    }
  })
  useEffect(() => {
    if (open === true) {
      const body = document.body
      body.style.overflow = 'hidden'
      // body.style.height = '100%'
    }
    if (open === false) {
      const body = document.body
      body.style.overflow = 'auto'
      // body.style.height = 'auto'
    }
  }, [open])

  return (
    <NavStateContext.Provider
      value={{
        open,
        setOpen,
        toggle,
        isLt768,
      }}
    >
      {children}
    </NavStateContext.Provider>
  )
}

export function useNav() {
  const context = React.useContext(NavStateContext)
  if (context === undefined) {
    throw new Error('useNav must be used within a NavProvider')
  }
  return context
}
